"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.OpenAQMeasurementsCodec = exports.OpenAQLatestCodec = void 0;

var t = __importStar(require("io-ts"));

var util_1 = require("../../util");

var OpenAQMetaCodec = t.type({
  found: t.number,
  license: t.string,
  limit: t.number,
  name: t.string,
  page: t.number,
  website: t.string
});
/**
 * Codec for the /v1/latest endpoint.
 *
 * @see https://docs.openaq.org/#api-Latest
 */

exports.OpenAQLatestCodec = t.type({
  meta: OpenAQMetaCodec,
  results: t.array(t.type({
    city: t.string,
    coordinates: util_1.latLngCodec,
    country: t.string,
    location: t.string,
    measurements: t.array(t.intersection([t.type({
      lastUpdated: t.string,
      parameter: util_1.pollutantCodec,
      sourceName: t.string,
      value: t.number,
      unit: util_1.unitCodec
    }), util_1.OpenAQCodecOptional]))
  }))
});
/**
 * Codec for the /v1/measurements endpoint.
 *
 * @see https://docs.openaq.org/#api-Measurements
 */

exports.OpenAQMeasurementsCodec = t.type({
  meta: OpenAQMetaCodec,
  results: t.array(util_1.OpenAQCodec)
});
var OpenAQErrorCodec = t.type({
  error: t.string,
  message: t.string,
  statusCode: t.number,
  validation: t.type({
    keys: t.record(t.number, t.string),
    source: t.string
  })
});